// Actions
export const ACTION_TYPES = {
  SAVE_USER: 'AUTH::SAVE_USER',
  SAVE_COMPANY: 'AUTH::SAVE_COMPANY',
};

// Action Creators
export const saveUser = user => ({ type: ACTION_TYPES.SAVE_USER, user });
export const saveCompany = company => ({ type: ACTION_TYPES.SAVE_COMPANY, company });

// Reducer
export default function authReducer(state = {
  user: null,
}, action) {
  switch(action.type) {
    case ACTION_TYPES.SAVE_USER: {
      return {
        ...state,
        user: action.user,
      }
    }
    case ACTION_TYPES.SAVE_COMPANY: {
      return {
        ...state,
        company: action.company,
      }
    }
    default : return state;
  }
}
